import PropTypes from 'prop-types';

import map from 'lodash/fp/map';

import styled from '@emotion/styled';

import Carousel from 'Components/Carousel';
import { breakpoints } from 'Components/ThemeProvider';
import Typography from 'Components/Typography';

import BlockLayout from 'Blocks/BlockLayout';

import useMedia from 'utils/useMedia';

const BlockTitle = styled(Typography)`
  margin-bottom: 48px;
`;

const SlideTitle = styled(Typography)`
  ${props => props.theme.breakpoints.up('md')} {
    font-size: 48px;
  }
`;

const SlideImage = styled.img`
  width: 150px;
  margin-top: 37px;
`;

const PressSlider = ({ content }) => {
  const isMobile = useMedia(`(max-width: ${breakpoints.md - 1}px)`);

  const { title, quotes } = content;

  return (
    <BlockLayout contentAlign="center" contentWidth="veryWide">
      <BlockTitle variant="mono1">{title}</BlockTitle>

      <Carousel
        key="press-carousel"
        arrows={false}
        bigArrows={!isMobile}
        controlsTheme="noir"
        dataFrom="block-press-reviews"
        heap="Press card"
        width={isMobile ? '100%' : '680px'}
      >
        {map(
          ({ quote, logo, alt }) => (
            <div key={quote}>
              <SlideTitle markupName="p" variant="h1">
                {quote}
              </SlideTitle>
              <div>
                <SlideImage alt={alt} src={logo.src} />
              </div>
            </div>
          ),
          quotes
        )}
      </Carousel>
    </BlockLayout>
  );
};

PressSlider.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    quotes: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
};

export default PressSlider;
